import axios from "@/plugins/axios";

async function contact(data) {
  return axios.post("?Mode=General&Function=Contact", data);
}

export { contact };
